/* eslint-disable rover/no-platform-specific-globals-or-imports */
import Rover from '@rover/globals/Rover';

import getUrlParameter from './getUrlParameter';
import { addEventParamsToUrl } from './url.server';

export { addEventParamsToUrl } from './url.server';

Rover.utils = Rover.utils || {};

Rover.utils.getUrlParameter = getUrlParameter;

Rover.utils.hasHashParam = (name) => {
  if (window.location.hash) {
    const hash = window.location.hash.substring(1);
    if (hash.indexOf(name) !== -1) {
      return true;
    }
  }
  return false;
};

export const redirect = (url) => {
  window.location = url;
};

export const getQueryParams = (queryString) => {
  let queryStringToProcess = queryString;
  if (!queryStringToProcess && window) {
    queryStringToProcess = window.location.search;
  }
  const params = new URLSearchParams(queryStringToProcess);
  return Array.from(params).reduce((obj, i) => {
    const key = i[0];
    const paramString = i[1];
    const paramsArray = params.getAll(key);
    const value = paramsArray.length > 1 ? paramsArray : paramString;
    return { ...obj, [key]: value };
  }, {});
};

window.isRoverURL = (url) =>
  url.indexOf('//') === -1 ||
  url.indexOf(Rover.urls.base) !== -1 ||
  url.indexOf('//localhost') !== -1 ||
  url.indexOf('//0.0.0.0') !== -1 ||
  url.indexOf('//127.0.0.1') !== -1;

export default {
  ...Rover.utils,
  redirect,
  addEventParamsToUrl,
};



// WEBPACK FOOTER //
// ../utilities/url.js